import warningGeneral from "../assets/warningGeneral.png";
import { CircularProgress, Modal } from "@mui/material";
import PropTypes from "prop-types";
import Button from "./Button";
import React from "react";

function ExpiredOtpModal(props) {
  const { open, isLoading, onResend, onCancel } = props;

  return (
    <Modal
      open={open}
      onClose={onCancel}
      sx={{ display: "flex", overflow: "auto", backdropFilter: "blur(8px)" }}
    >
      <div className="sm:w-89.5 w-72 bg-white m-auto rounded-2xl p-6">
        <div className="flex items-center justify-center">
          <img src={warningGeneral} alt="error icon" width="60px" />
        </div>
        <div className="text-center font-semibold mt-1">OTP Expired</div>
        <div className="text-center">Oops! OTP is expired. Resend?</div>
        <div className="mt-3">
          <Button
            disabled={isLoading}
            className={`w-full mb-2 ${
              isLoading ? "text-[#A3A7AB] bg-[#F6F7F7]" : "text-white"
            }`}
            onClick={onResend}
          >
            {isLoading ? <CircularProgress size="1rem" /> : "Resend"}
          </Button>
          <Button className="w-full bg-white border" onClick={onCancel}>
            Don't resend
          </Button>
        </div>
      </div>
    </Modal>
  );
}

ExpiredOtpModal.propTypes = {
  onResend: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
};

export default ExpiredOtpModal;
